module.exports = __webpack_public_path__ + "static/media/etienne.abff1268.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionGenius/medias/etienne.png
// module id = 233
// module chunks = 0